<template>
  <div class="form-builder">
    <CustomFields :schema="schema" :data="valueComp" v-model="valueComp" :validator="validator" />
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import CustomFields from '@kvass/custom-fields'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    schema: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    valueComp: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  components: {
    CustomFields,
    InputComponent,
  },
}
</script>

<style lang="scss">
.form-builder {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr;
  grid-gap: math.div($form-gap-row, 2) $form-gap-column;
  align-items: flex-start;
}
</style>
